import { Fragment, useState } from "react";
import useStripeConnect from "../../../services/payments/useStripeConnect";
import DisplayConnectAccountOnboarding from "./DisplayConnectAccountOnboarding";
import PendingAccountStatusMessage from "./PendingAccountStatusMessage";
import AcceptedAccountStatusMessage from "./AcceptedAccountStatusMessage";
import RejecteddAccountStatusMessage from "./RejectedAccountStatusMessage";
import { useAtom } from "jotai/react";
import { getUpdateOnboardProcess } from "./storeStates";

function StatusConnectedAccount(props) {
  // Embedded Onboard process is checked in hatoi
  const [finishOnboard,] = useAtom(getUpdateOnboardProcess) 

  const token = props.token;
  const connectedAccountId = props.connectedAccountId;
  const accountRejected = props.accountRejected;
  const pendingVerification = props.pendingVerification;
  const chargesEnabled = props.chargesEnabled;
  const payoutsEnabled = props.payoutsEnabled;
  const [stripeInstance, setStripeInstance] = useState(false);
  const stripeConnectInstance = useStripeConnect(connectedAccountId, token);

  function handleContinueOnboarding() {
    setStripeInstance(stripeConnectInstance);
  }

  return (
    <Fragment>
      {!finishOnboard && !stripeInstance && (
        <div id="terms">
          <p>
            Completing your onboarding will give you full access to all of our
            features and ensure a smooth experience on our platform. To start
            accepting payments and manage your earnings on{" "}
            <strong>Plaintr</strong>, you need to onboard your account with
            <strong> Stripe</strong>, our payment processing partner. This setup
            is quick and easy, and it will enable you to:
          </p>

          <div>
            <button
              style={{ margin: "0 auto", marginTop: "40px" }}
              className="btn btnBox"
              onClick={handleContinueOnboarding}
            >
              <b>Finish Onboard</b>
            </button>
          </div>
        </div>
      )}
      {!finishOnboard && stripeInstance && (
        <DisplayConnectAccountOnboarding
          stripeConnectInstance={stripeConnectInstance}
        />
      )}
      {finishOnboard && accountRejected && <RejecteddAccountStatusMessage />}
      {finishOnboard && pendingVerification && !accountRejected && (
        <PendingAccountStatusMessage />
      )}
      {finishOnboard &&
        !pendingVerification &&
        !accountRejected &&
        chargesEnabled &&
        payoutsEnabled && <AcceptedAccountStatusMessage />}
    </Fragment>
  );
}

export default StatusConnectedAccount;
